import RestaurantListBlock, {
  RestaurantListBlockProps
} from './RestaurantListBlock'
import withInteractor from './RestaurantListBlock.interactor'
import withPresenter from './RestaurantListBlock.presenter'

export type { RestaurantListBlockProps }
export default withInteractor(withPresenter(RestaurantListBlock))
